import React, { useEffect } from 'react';
import usePageProtection from './hooks/usePageProtection';

const ProtectionWrapper = ({ children }) => {
  usePageProtection();

  useEffect(() => {
    const protectTextareas = () => {
      const textareas = document.querySelectorAll('textarea.QuestionPrompt');
      textareas.forEach((textarea) => {
        // Only protect if it's not a form input
        if (
          !textarea.closest('.MuiFormControl-root') &&
          !textarea.closest('.form-group') &&
          !textarea.closest('.EmailInput') &&
          !textarea.closest('.highlighted-text-container') &&
          !textarea.closest('.email-input-wrapper')
        ) {
          // Disable all text interaction
          textarea.style.userSelect = 'none';
          textarea.style.webkitUserSelect = 'none';
          textarea.style.mozUserSelect = 'none';
          textarea.style.msUserSelect = 'none';
          textarea.style.pointerEvents = 'none';
          textarea.style.cursor = 'default';

          // Block events
          const blockEvent = (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
          };

          textarea.addEventListener('selectstart', blockEvent, true);
          textarea.addEventListener('select', blockEvent, true);
          textarea.addEventListener('copy', blockEvent, true);
          textarea.addEventListener('cut', blockEvent, true);
          textarea.addEventListener('paste', blockEvent, true);
          textarea.addEventListener('drag', blockEvent, true);
          textarea.addEventListener('dragstart', blockEvent, true);
          textarea.addEventListener('mousedown', blockEvent, true);
        }
      });
    };

    // Apply protection after component mounts
    setTimeout(protectTextareas, 100);

    // Re-apply when content changes
    const observer = new MutationObserver(protectTextareas);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return <>{children}</>;
};

export default ProtectionWrapper;